import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Employeetransportationservice() {



const cardData = {
  keyword: " Employee Transportation Services Pune ",

"headingDescription": "SRS Cab Service provides Employee Transportation Services in Pune, ensuring safe, reliable, and comfortable travel solutions for corporate teams. Whether it’s daily office commutes, shuttle services, or corporate outings, our well-maintained vehicles and professional drivers offer punctual and stress-free transportation. With flexible routes, transparent pricing, and 24/7 customer support, SRS Cab Service makes employee commuting in Pune efficient, convenient, and hassle-free.",
"topPlaces": [
  {
    "title": "Rajiv Gandhi Infotech Park",
    "description": "A major IT hub in Pune where corporate employees frequently travel. Companies use SRS Cab Service for smooth employee transportation to this location."
  },
  {
    "title": "Hinjewadi Phase 1 & 2",
    "description": "One of Pune’s largest corporate zones. SRS Cab Service ensures timely employee pick-ups and drop-offs for offices in Hinjewadi."
  },
  {
    "title": "Magarpatta City",
    "description": "A prominent corporate and IT campus. Employee transportation services from SRS Cab Service help teams commute efficiently."
  },
  {
    "title": "EON IT Park",
    "description": "SRS Cab Service provides corporate commuting solutions for employees working at EON IT Park, ensuring punctuality and comfort."
  },
  {
    "title": "Kalyani Nagar",
    "description": "A corporate and residential hub in Pune. Employee transportation services cover pick-ups and drop-offs for professionals residing here."
  },
  {
    "title": "Viman Nagar",
    "description": "Many corporate offices are located here. SRS Cab Service facilitates convenient commuting for employees in this area."
  },
  {
    "title": "Baner",
    "description": "An IT and commercial locality. SRS Cab Service ensures seamless corporate transportation for employees traveling to and from Baner."
  },
  {
    "title": "Pimpri Chinchwad Industrial Area",
    "description": "Industrial and corporate offices rely on SRS Cab Service for safe and timely employee transportation."
  },
  {
    "title": "Hadapsar",
    "description": "A fast-growing corporate and commercial hub. Employee transportation services from SRS Cab Service help teams maintain punctuality."
  },
  {
    "title": "Wakad",
    "description": "A residential and IT hub where many employees live. SRS Cab Service provides reliable commuting solutions for professionals from Wakad."
  }
],



services: [
{
name: "Corporate Cabs Service in Pune",
description: "Corporate cabs service in Pune offers reliable transportation for companies and employees. Businesses can book daily pickup and drop services. Professional drivers ensure safe travel. Comfortable vehicles enhance employee experience. Flexible scheduling options are available. Travel easily with corporate cab services."
},
{
name: "Employee Transportation Services Pune",
description: "Employee transportation services Pune provide efficient travel solutions for office staff. Companies can arrange daily commute for employees. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible routes and timing are available. Travel easily with employee transport services."
},
{
name: "Employee Transport Service Pune",
description: "Employee transport service Pune offers dependable travel for office staff and teams. Businesses can schedule pickup and drop services. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with employee transport services."
},
{
name: "Staff Transportation Services Pune",
description: "Staff transportation services Pune provide smooth and organized travel for company employees. Businesses can book transport for daily office commute. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible scheduling options are available. Travel easily with staff transport services."
},
{
name: "Staff Transport Service Pune",
description: "Staff transport service Pune offers reliable travel for office teams and workers. Companies can arrange daily commute services. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with staff transport services."
},
{
name: "Corporate Employee Transport Pune",
description: "Corporate employee transport Pune provides organized travel for business employees. Companies can manage daily pickup and drop efficiently. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible routes are available. Travel easily with corporate transport services."
},
{
name: "Office Staff Transport Pune",
description: "Office staff transport Pune offers convenient travel solutions for employees. Businesses can book transport for daily office commute. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible timing options are available. Travel easily with staff transport services."
},
{
name: "Company Transportation Service Pune",
description: "Company transportation service Pune provides reliable travel for corporate employees. Businesses can arrange daily pickup and drop services. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with company transport services."
},
{
name: "Employee Cab Service Pune",
description: "Employee cab service Pune offers convenient travel for office staff and teams. Companies can book cabs for daily commute. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible scheduling options are available. Travel easily with employee cab services."
},
{
name: "Corporate Cab Service Pune for Employees",
description: "Corporate cab service Pune for employees provides organized transport for businesses. Companies can ensure timely office commute for staff. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with corporate cab services."
},
{
name: "Staff Pickup and Drop Service Pune",
description: "Staff pickup and drop service Pune offers reliable travel for employees. Companies can arrange daily transportation schedules. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible routes are available. Travel easily with pickup and drop services."
},
{
name: "Employee Shuttle Service Pune",
description: "Employee shuttle service Pune provides group transport for office teams. Businesses can arrange shared travel for employees. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible timing options are available. Travel easily with shuttle services."
},
{
name: "Corporate Transport Service Pune",
description: "Corporate transport service Pune offers efficient travel solutions for businesses. Companies can book transport for daily operations. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with corporate transport services."
},
{
name: "Employee Commute Service Pune",
description: "Employee commute service Pune provides smooth daily travel for office staff. Companies can arrange regular transport services. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible routes are available. Travel easily with commute services."
},
{
name: "Employee Cab Booking Pune",
description: "Employee cab booking Pune offers easy reservation options for corporate travel. Businesses can book cabs for employees anytime. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab booking services."
},
{
name: "Staff Taxi Service Pune",
description: "Staff taxi service Pune provides reliable transportation for company employees. Businesses can book taxis for daily office travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible scheduling options are available. Travel easily with taxi services."
},
{
name: "Office Transport Cab Pune",
description: "Office transport cab Pune offers convenient travel solutions for employees. Companies can arrange cabs for daily commute. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with office transport services."
},
{
name: "Employee Travel Service Pune",
description: "Employee travel service Pune provides reliable travel solutions for business staff. Companies can arrange transport for office and outstation trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with travel services."
},
{
name: "Corporate Employee Cab Booking Pune",
description: "Corporate employee cab booking Pune offers quick and easy booking for companies. Businesses can manage employee transport efficiently. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible scheduling options are available. Travel easily with corporate booking services."
},
{
name: "Employee Transport Provider Pune",
description: "Employee transport provider Pune offers complete transport solutions for companies. Businesses can outsource employee travel services. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible service plans are available. Travel easily with transport providers."
},
{
name: "Company Cab Service Pune",
description: "Company cab service Pune provides reliable travel for corporate employees. Businesses can arrange daily pickup and drop services. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with company cab services."
},
{
name: "Innova Employee Transport Pune",
description: "Innova employee transport Pune offers spacious SUV travel for corporate staff. Companies can book vehicles for team travel. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Ideal for group commute. Travel easily with Innova transport services."
},
{
name: "Innova Crysta Staff Transport Pune",
description: "Innova Crysta staff transport Pune provides premium SUV travel for employees. Companies can ensure comfortable daily commute. Professional drivers ensure safe journeys. Spacious seating enhances experience. Ideal for corporate travel. Travel easily with Innova Crysta services."
},
{
name: "Ertiga Employee Cab Pune",
description: "Ertiga employee cab Pune offers comfortable 7 seater travel for staff transport. Companies can book vehicles for team commute. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Ertiga cab services."
},
{
name: "Dzire Staff Transport Pune",
description: "Dzire staff transport Pune provides affordable sedan travel for employee commute. Companies can book vehicles for daily travel. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with sedan cab services."
},
{
name: "Sedan Employee Transport Pune",
description: "Sedan employee transport Pune offers budget-friendly travel for office staff. Companies can book vehicles for daily commute. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with sedan transport services."
},
{
name: "SUV Employee Transport Pune",
description: "SUV employee transport Pune provides spacious travel for corporate teams. Companies can book vehicles for group travel. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with SUV transport services."
},
{
name: "Tempo Traveller Employee Transport Pune",
description: "Tempo traveller employee transport Pune offers group travel for office staff. Companies can book vehicles for large teams. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with tempo traveller services."
},
{
name: "Urbania Employee Transport Pune",
description: "Urbania employee transport Pune provides premium group travel for corporate staff. Companies can book luxury vehicles for teams. Professional drivers ensure safe journeys. Spacious seating enhances comfort. Flexible booking options are available. Travel easily with Urbania transport services."
}
],

tableData: [
["Corporate Cabs Service in Pune","Employee Transportation Services Pune"],
["Employee Transport Service Pune","Staff Transportation Services Pune"],
["Staff Transport Service Pune","Corporate Employee Transport Pune"],
["Office Staff Transport Pune","Company Transportation Service Pune"],
["Employee Cab Service Pune","Corporate Cab Service Pune for Employees"],
["Staff Pickup and Drop Service Pune","Employee Shuttle Service Pune"],
["Corporate Transport Service Pune","Employee Commute Service Pune"],
["Employee Cab Booking Pune","Staff Taxi Service Pune"],
["Office Transport Cab Pune","Employee Travel Service Pune"],
["Corporate Employee Cab Booking Pune","Employee Transport Provider Pune"],
["Company Cab Service Pune","Innova Employee Transport Pune"],
["Innova Crysta Staff Transport Pune","Ertiga Employee Cab Pune"],
["Dzire Staff Transport Pune","Sedan Employee Transport Pune"],
["SUV Employee Transport Pune","Tempo Traveller Employee Transport Pune"],
["Urbania Employee Transport Pune","Corporate Cabs Service in Pune"]
],



whychoose: [
  {
    WhyChooseheading: "Professional Employee Transportation Services in Pune",
    WhyChoosedescription: "SRS Cab Service provides reliable employee transportation services in Pune for IT companies, corporates, BPOs, and industries with safe, punctual, and well-managed staff commute solutions."
  },
  {
    WhyChooseheading: "Customized Corporate Transport Solutions",
    WhyChoosedescription: "We offer fully customized employee transport plans including shift-based pickup, route optimization, and dedicated fleet services tailored to your company requirements."
  },
  {
    WhyChooseheading: "24/7 Staff Transportation Availability",
    WhyChoosedescription: "Our employee transport service operates 24/7 to support night shifts, early morning shifts, and flexible working hours for IT parks and corporate offices in Pune."
  },
  {
    WhyChooseheading: "Wide Range of Fleet Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, mini buses, and AC buses for small to large employee groups."
  },
  {
    WhyChooseheading: "GPS Tracking & Safety Features",
    WhyChoosedescription: "All vehicles are equipped with GPS tracking, ensuring real-time monitoring, employee safety, and route efficiency for corporate travel management."
  },
  {
    WhyChooseheading: "Verified Drivers & Safety Compliance",
    WhyChoosedescription: "Our drivers are background-verified, trained, and experienced to ensure safe driving, professional behavior, and compliance with corporate safety policies."
  },
  {
    WhyChooseheading: "On-Time Pickup & Route Management",
    WhyChoosedescription: "We ensure timely pickups and drops with optimized route planning, reducing delays and improving employee productivity."
  },
  {
    WhyChooseheading: "Trusted Corporate Transport Partner in Pune",
    WhyChoosedescription: "SRS Cab Service is trusted by companies across Pune for reliable employee transportation, affordable pricing, and high-quality service standards."
  }
]
}

const faqData = [
  { 
    question: "Do you provide employee transportation services in Pune?", 
    answer: "Yes, SRS Cab Service offers professional employee transportation services in Pune for IT companies, corporates, BPOs, and industrial staff with safe and reliable commute solutions." 
  },
  { 
    question: "Can transport services be customized for company needs?", 
    answer: "Yes, we provide customized employee transport solutions including shift-wise pickup, route planning, dedicated vehicles, and flexible scheduling based on company requirements." 
  },
  { 
    question: "Is employee transport service available 24/7?", 
    answer: "Yes, our employee transportation services operate 24/7 to support night shifts, early morning shifts, and continuous business operations." 
  },
  { 
    question: "Which vehicles are available for employee transport?", 
    answer: "We offer a wide range of vehicles including sedans, SUVs, Innova Crysta, Tempo Travellers, mini buses, and AC buses depending on team size and travel needs." 
  },
  { 
    question: "Do you provide GPS tracking for employee safety?", 
    answer: "Yes, all vehicles are equipped with GPS tracking systems for real-time monitoring and enhanced employee safety during travel." 
  },
  { 
    question: "Are drivers verified and trained?", 
    answer: "Yes, all drivers are background-verified, trained, and experienced to ensure safe and professional service for corporate transportation." 
  },
  { 
    question: "Do you provide transport for IT companies in Hinjewadi?", 
    answer: "Yes, we provide employee transportation services for IT companies in Hinjewadi, Baner, Wakad, and other major corporate hubs in Pune." 
  },
  { 
    question: "Is transport available for small and large teams?", 
    answer: "Yes, we provide transport solutions for both small teams and large employee groups with flexible fleet options." 
  },
  { 
    question: "Are services cost-effective for companies?", 
    answer: "Yes, we offer affordable corporate transport solutions with transparent pricing and cost-effective plans for long-term contracts." 
  },
  { 
    question: "How can companies book employee transportation services?", 
    answer: "Companies can easily book employee transport services by contacting us directly. We provide quick onboarding and seamless service setup." 
  }
];

const testimonials = [
  {
    id: 1,
    name: "HR Manager - IT Company",
    feedback:
      "We have been using SRS Cab Service for employee transportation in Pune and the service has been excellent. On-time pickups, professional drivers, and proper coordination make daily operations smooth.",
    rating: 5
  },
  {
    id: 2,
    name: "Operations Head - Corporate Firm",
    feedback:
      "Best employee transportation service provider in Pune. Their fleet management, safety measures, and punctuality are impressive. Highly recommended for corporate staff transport.",
    rating: 5
  }
];



















const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];













const jsonData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SRS Cab - Employee Transportation Services Pune",
  "description": "Reliable corporate and employee transportation services in Pune with SRS Cab. Staff pickup and drop, office shuttle, corporate employee cab booking, and commute services available 24/7 with Innova, Ertiga, sedan, SUV, and tempo traveller options.",
  "image": "https://www.srscabservice.com/logo.png",
  "telephone": "+91 9011955415",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Pune",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411001",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "18.5204",
    "longitude": "73.8567"
  },
  "url": "https://www.srscabservice.com/employee-transportation-pune",
  "priceRange": "₹₹",
  "openingHours": "Mo-Su 00:00-23:59",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": "1475"
  },
  "areaServed": {
    "@type": "City",
    "name": "Pune, Maharashtra"
  }
};






  return (
    <div>
      


<Helmet>
  <title>Employee Transportation Services in Pune | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Book reliable employee transportation services in Pune with SRS Cab. Staff pickup/drop, corporate shuttle, and employee commute services available 24/7. Innova, Ertiga, sedan, SUV, and tempo traveller options." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/102.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Employeetransportationservice;